class CustomTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabContents = Array.from(this.querySelectorAll('[role="tabcontent"]'));

        this.tabButtons.forEach((button, index) => {
            button.addEventListener('click', this.handleTabClick.bind(this));
            if (index === 0) {
                this.activateTab(button);
            }
        });
    }

    handleTabClick(event) {
        this.activateTab(event.currentTarget);
    }

    activateTab(activeButton) {
        this.tabButtons.forEach((button) => {
            button.setAttribute('aria-selected', button === activeButton);
        });

        this.tabContents.forEach((content) => {
            content.hidden = content.getAttribute('aria-labelledby') !== activeButton.id;
        });
    }
}

customElements.define('custom-tabs', CustomTabs);